import { Injectable } from '@angular/core';
import { HttpClientService } from '../utils/http-client.module';
import { URLSearchParams } from '@angular/http';
import { PageForm } from './form.model';
import { APPCONFIG } from '../../app/config';
import { AuthenticateService } from '../auth/authentication.service';
import { CookieClientService } from '../utils/cookieClient';
import { saveAs } from 'file-saver';
import { ErrorManager} from '../utils/errorManager';

import 'rxjs/Rx' ;
@Injectable()
export class CalculateService  {

  config = APPCONFIG;

  constructor(public _http: HttpClientService, public authenticateService: AuthenticateService, private _cookie:CookieClientService, public errorManager: ErrorManager) { }

  checkAuthorization(){
    if(this._cookie.cookieOpts.expires) {
      let currenDate  = new Date();
      currenDate.setTime(currenDate.getTime() + (1000*60*30));
      this._cookie.setValue(btoa('authorization'), this._cookie.getValue(btoa('authorization')), currenDate);
    }
  }
  
  uploadFiles(formData : FormData) {
      this.checkAuthorization();
    return this._http.multipart(this.config.ApiHost+ '/uploadFiles', formData);
  }

  getUploadLogs(queryStr?:string){
      this.checkAuthorization();
    return this._http.get(this.config.ApiHost+ '/upload/logs',new URLSearchParams(queryStr));
  }

  getCalculateGroupByStores(queryStr?:string){
      this.checkAuthorization();
    return this._http.get(this.config.ApiHost+ '/calculations/search/aggregate',new URLSearchParams(queryStr));
  }
  
  getCalculateGroupByDate(queryStr?:string){
      this.checkAuthorization();
    return this._http.get(this.config.ApiHost+ '/calculations/aggregate',new URLSearchParams(queryStr));
  }
  
  getCalculateGroupByDailyInputSearchFilter(queryStr?:string){
      this.checkAuthorization();
    return this._http.get(this.config.ApiHost+ '/calculations/search',new URLSearchParams(queryStr));
  }
  
  getCalculateGroupByDaily(queryStr?:string){
      this.checkAuthorization();
    return this._http.get(this.config.ApiHost+ '/calculations',new URLSearchParams(queryStr));
  }
  
  getVendorHq(){
      this.checkAuthorization();
    return this._http.get(this.config.ApiHost+ '/vendors/hq',new URLSearchParams());  
  }
  
  downloadExcelStep1(queryStr?:string){
      this.checkAuthorization();
    return this._http.get(this.config.ApiHost+ '/downloadExcel/search/aggregate',new URLSearchParams(queryStr), true);    
  }
  
  downloadExcelStep2(queryStr?:string){
      this.checkAuthorization();
    return this._http.get(this.config.ApiHost+ '/downloadExcel/aggregate',new URLSearchParams(queryStr), true);    
  }
  
  downloadExcelStep3(queryStr?:string){
      this.checkAuthorization();
    return this._http.get(this.config.ApiHost+ '/downloadExcel',new URLSearchParams(queryStr), true);    
  }
  
  downloadExcempleFile(){
    this._http.get('/assets/customer-ex.xlsx' ,null, true).subscribe(data => this.downloadFile(data ,'고객사 정산조회 업로드 양식 V1.0.xlsx' )),
      error => this.errorManager.catchedError(JSON.parse(error['_body'])),
      () => console.info("OK");
  }
  
  downloadFile(data, fileName){
    var blob = new Blob([data['_body']], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob,fileName);
  }  
  
  downloadFailedExcelData(fileNo:number, fileName:string){
    this._http.get(this.config.ApiHost+ '/downloadExcel/failed/' + fileNo,null, true).subscribe(data => this.downloadFile(data ,fileName )),
      error => this.errorManager.catchedError(JSON.parse(error['_body'])),
      () => console.info("OK");
  }  

  setCalculateRecords(modifyData:any[]){
    return this._http.put(this.config.ApiHost+ '/calculations',modifyData);
  }
}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/calculate/calculate.service.ts